import React from "react";
import styled from "styled-components";
import { DragIcon } from "./icons/DragIcon";

type Props = {
  isOpen: boolean;
  children?: React.ReactNode;
  togglePanel: () => void;
};

type PaneProps = { isOpen: boolean };
const Pane = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 95vw;
  height: 98vh;
  position: absolute;
  box-sizing: border-box;
  background: inherit;
  flex-direction: column;
  padding: 40px 10px 0 10px;
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  transition: transform 0.8s cubic-bezier(0.71, -0.45, 0.32, 1.45);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  transform: ${({ isOpen }: PaneProps) =>
    isOpen ? "translateY(-10%)" : "translateY(-90%)"};
`;

const StyledToggleBar = styled.div`
  min-height: 50px;
  padding: 8px 0px 8px 0px;
  width: 100%;
  display: flex;
  flex: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  align-self: flex-end;
`;

const Content = styled.div`
  width: 100%;
  height: calc(90% - 50px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
`;

export const SlidingPane = ({ isOpen, children, togglePanel }: Props) => (
  <Pane isOpen={isOpen}>
    <Content>{children}</Content>
    <StyledToggleBar>
      <DragIcon onClick={togglePanel} />
    </StyledToggleBar>
  </Pane>
);
